import { render, staticRenderFns } from "./CardInfoBLCapture.vue?vue&type=template&id=7f9c972f&scoped=true&"
import script from "./CardInfoBLCapture.vue?vue&type=script&lang=js&"
export * from "./CardInfoBLCapture.vue?vue&type=script&lang=js&"
import style0 from "./CardInfoBLCapture.vue?vue&type=style&index=0&id=7f9c972f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c972f",
  null
  
)

export default component.exports